// Mixtures State

export default {
  fullMixturesList: [],
  mixturesList: [],
  mixtureInfo: {}
}
